import {
  HttpError,
  IBlocSyncInteractor,
  SyncInteractor
} from "@kernel/frontend-react-app";

export interface HttpErrorProps {
  err: HttpError;
}

export class HttpErrorInteractor
  extends SyncInteractor<HttpErrorProps, string>
  implements IBlocSyncInteractor<HttpErrorProps, string>
{
  public execute({ err }: HttpErrorProps): string {
    const errorString = `[${err.code}] ${err.message}`;
    return errorString;
  }

  public static create() {
    return new HttpErrorInteractor();
  }
}
